import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils.js'
import EHRFeatures from '@/services/ehrfeatures.service'
import LocalStorage from '@/services/storage.service'

export default {
     mixins: [DBFunctions],
     data() {
          return {
               isUseAsam: false,
               EHRReadOnlyList: []
          }
     },
     methods: {
          async setPermissions() {
               this.EHRReadOnlyList = await this.getIsReadOnly('');          
               if(this.EHRReadOnlyList) {

                    this.$store.commit('setLettersEHRReadOnly',this.isNoteReadOnly('FORMGEN'));
                    this.$store.commit('setDrugInboxFillEHRReadOnly',this.isNoteReadOnly('DIFILL'));
                    this.$store.commit('setDrugInboxAllergiesEHRReadOnly',this.isNoteReadOnly('DIALLERGIES'));
                    this.$store.commit('setDrugInboxFormularyStatusEHRReadOnly',this.isNoteReadOnly('FORMULARYSTATUS'));                    
                    this.$store.commit('setDrugInboxDrugInfoEHRReadOnly',this.isNoteReadOnly('DIDRUGINFO'));
                    this.$store.commit('setDrugInboxPatientInfoEHRReadOnly',this.isNoteReadOnly('DIPATINFO'));
                    this.$store.commit('setDrugInboxPharmacyNotesEHRReadOnly',this.isNoteReadOnly('DINOTES'));
                    this.$store.commit('setDrugInboxPrescriptionEHRReadOnly',this.isNoteReadOnly('DIPRESCRIPTION'));
                    this.$store.commit('setDrugInboxPrintMedLabelEHRReadOnly',this.isNoteReadOnly('DIPRINTLABEL'));
                    this.$store.commit('setDrugInboxPrintMedicationHistoryEHRReadOnly',this.isNoteReadOnly('DIMEDHISTORY'));
                    this.$store.commit('setDrugInboxReturnedItemsEHRReadOnly',this.isNoteReadOnly('DIRETURNEDITEMS'));
                    this.$store.commit('setDrugInboxSetToChargeableEHRReadOnly',this.isNoteReadOnly('DICHARGEABLE'));
                    this.$store.commit('setDrugInboxSetToPendingEHRReadOnly',this.isNoteReadOnly('DIPENDING'));
                    this.$store.commit('setDrugInboxSetToUnableToFillEHRReadOnly',this.isNoteReadOnly('DIUNABLETOFILL'));
                    this.$store.commit('setDrugInboxSetToValidEHRReadOnly',this.isNoteReadOnly('DIVALID'));
                    this.$store.commit('setDrugInboxUndoFillOrderEHRReadOnly',this.isNoteReadOnly('DIUNDOFILL'));
                    this.$store.commit('setDrugInboxUndoSetToChargeableEHRReadOnly',this.isNoteReadOnly('DIUNDOCHARGEABLE'));
                    this.$store.commit('setDrugInboxUndoSetToPendingEHRReadOnly',this.isNoteReadOnly('DIORDER'));
                    this.$store.commit('setDrugInboxUndoValidatedEHRReadOnly',this.isNoteReadOnly('DIUNDOVALID'));               



                    this.$store.commit('setASAMEHRReadOnly',this.isNoteReadOnly('ASAM'));
                    this.$store.commit('setPatientInfoEHRReadOnly',this.isNoteReadOnly('PATIENTINFO')); 
                    this.$store.commit('setPatientInsuranceEHRReadOnly',this.isNoteReadOnly('PATIENTINSURANCE'));
                    this.$store.commit('setPatientContactsEHRReadOnly',this.isNoteReadOnly('PATIENTCONTACTS'));
                    this.$store.commit('setClinicalNotesEHRReadOnly',this.isNoteReadOnly('CLINICAL_NOTESUS'));
                    this.$store.commit('setVitalSignEHRReadOnly',this.isNoteReadOnly('VITAlSIGNS'));
                    this.$store.commit('setPatientAllergiesEHRReadOnly',this.isNoteReadOnly('PATIENTALLERGIES'));
                    this.$store.commit('setPatientSpecialPrEHRReadOnly',this.isNoteReadOnly('PATIENTSPECIALPR'));
                    this.$store.commit('setPatientMarsAlertEHRReadOnly',this.isNoteReadOnly('PATIENTMARALERT'));
                    this.$store.commit('setPatientAdmissionEHRReadOnly',this.isNoteReadOnly('ADMISSION'));
                    this.$store.commit('setClinicalTransferEHRReadOnly',this.isNoteReadOnly('PROGTRANSFER'));
                    this.$store.commit('setClinicalMedicationsEHRReadOnly',this.isNoteReadOnly('MEDICATIONS'));
                    this.$store.commit('setClinicalDischargeEHRReadOnly',this.isNoteReadOnly('PATDISCHARGE'));
                    this.$store.commit('setPatientDiagnosisEHRReadOnly',this.isNoteReadOnly('PATIENTDIAGNOSIS'));
                    this.$store.commit('setDailyNotesEHRReadOnly',this.isNoteReadOnly('DAILY NOTES'));
                    this.$store.commit('setPatientDocumentEHRReadOnly',this.isNoteReadOnly('PATIENTDOCUMENTS'));
                    this.$store.commit('setLogNotesEHRReadOnly',this.isNoteReadOnly('LOGNOTES'));
                    this.$store.commit('setSchedulerClinicalEHRReadOnly',this.isNoteReadOnly('SCHED_CLINICAL'));
                    this.$store.commit('setAppointmentsEHRReadOnly',this.isNoteReadOnly('APPOINTMENTS'));
                    this.$store.commit('setTreatmentPlanEHRReadOnly',this.isNoteReadOnly('TREATMENTPLAN'));
                    this.$store.commit('setEPrescribingEHRReadOnly',this.isNoteReadOnly('NEWCROP'));
                    this.$store.commit('setMarsEHRReadOnly',this.isNoteReadOnly('MARS'));
                    this.$store.commit('setTarsEHRReadOnly',this.isNoteReadOnly('TARS'));
                    this.$store.commit('setPatientAlertsEHRReadOnly',this.isNoteReadOnly('ALERTS'));
                    this.$store.commit('setPatientActivitiesEHRReadOnly',this.isNoteReadOnly('NOTES'));
                    this.$store.commit('setPatientClaimsEHRReadOnly',this.isNoteReadOnly('PATIENTCLAIMS'));
                    this.$store.commit('setPhysiciansOrderEHRReadOnly',this.isNoteReadOnly('ORDERS'));
               } else {
                    this.setAllReadOnly(false)
               }
               this.isUseAsam = await this.getUseASAM();
               this.parameter.UserId = LocalStorage.getUserId();

               EHRFeatures.getByUsers(this.parameter)
                    .then((response) => {
                         if(response.status == '200' && response.data){
                              const ehrFeaturesList = response.data;                                   
                              let arr = [];      

                              if(ehrFeaturesList && ehrFeaturesList.length > 0) {
                                   const ehrFeatures = ehrFeaturesList[0].ehrFeatures.trim();
                                   if (!Utils.isNullOrEmptyString(ehrFeatures)) {
                                        arr = ehrFeatures.split(',');
                                   }
                              }

                              if(arr.length > 0) {
                                   this.$store.commit('setUseLetters', arr.indexOf('FORMGEN') !== -1);
                                   this.$store.commit('setUseMars', arr.indexOf('MARS') !== -1);
                                   this.$store.commit('setUseDrugInboxFill', arr.indexOf('DIFILL') !== -1);
                                   this.$store.commit('setUseDrugInboxAllergies', arr.indexOf('DIALLERGIES') !== -1);
                                   this.$store.commit('setUseDrugInboxFormularyStatus', arr.indexOf('FORMULARYSTATUS') !== -1);                                   
                                   this.$store.commit('setUseDrugInboxDrugInfo', arr.indexOf('DIDRUGINFO') !== -1);
                                   this.$store.commit('setUseDrugInboxPatientInfo', arr.indexOf('DIPATINFO') !== -1);
                                   this.$store.commit('setUseDrugInboxPharmacyNotes', arr.indexOf('DINOTES') !== -1);
                                   this.$store.commit('setUseDrugInboxPrescription', arr.indexOf('DIPRESCRIPTION') !== -1);
                                   this.$store.commit('setUseDrugInboxPrintMedLabel', arr.indexOf('DIPRINTLABEL') !== -1);
                                   this.$store.commit('setUseDrugInboxPrintMedicationHistory', arr.indexOf('DIMEDHISTORY') !== -1);
                                   this.$store.commit('setUseDrugInboxReturnedItems', arr.indexOf('DIRETURNEDITEMS') !== -1);
                                   this.$store.commit('setUseDrugInboxSetToChargeable', arr.indexOf('DICHARGEABLE') !== -1);
                                   this.$store.commit('setUseDrugInboxSetToPending', arr.indexOf('DIPENDING') !== -1);
                                   this.$store.commit('setUseDrugInboxSetToUnableToFill', arr.indexOf('DIUNABLETOFILL') !== -1);
                                   this.$store.commit('setUseDrugInboxSetToValid', arr.indexOf('DIVALID') !== -1);
                                   this.$store.commit('setUseDrugInboxUndoFillOrder', arr.indexOf('DIUNDOFILL') !== -1);
                                   this.$store.commit('setUseDrugInboxUndoSetToChargeable', arr.indexOf('DIUNDOCHARGEABLE') !== -1);
                                   this.$store.commit('setUseDrugInboxUndoSetToPending', arr.indexOf('DIORDER') !== -1);
                                   this.$store.commit('setUseDrugInboxUndoValidated', arr.indexOf('DIUNDOVALID') !== -1);                    


                                   this.$store.commit('setUsePatientAdmission', arr.indexOf('ADMISSION') !== -1);
                                   this.$store.commit('setUseTransfer', arr.indexOf('PROGTRANSFER') !== -1);
                                   this.$store.commit('setUseMedications', arr.indexOf('MEDICATIONS') !== -1);
                                   this.$store.commit('setDailyNotes', arr.indexOf('"DAILY NOTES"') !== -1);
                                   this.$store.commit('setLogNotes', arr.indexOf('LOGNOTES') !== -1);
                                   this.$store.commit('setUsePatientDiagnosis', arr.indexOf('PATIENTDIAGNOSIS') !== -1);
                                   this.$store.commit('setUseDischarge', arr.indexOf('PATDISCHARGE') !== -1);
                                   this.$store.commit('setUsePatientInfo', arr.indexOf('PATIENTINFO') !== -1);
                                   this.$store.commit('setUsePatientInsurance', arr.indexOf('PATIENTINSURANCE') !== -1);
                                   this.$store.commit('setUsePatientContact', arr.indexOf('PATIENTCONTACTS') !== -1);
                                   this.$store.commit('setUseASAM', arr.indexOf('ASAM') !== -1 && this.isUseAsam);
                                   this.$store.commit('setUseClinicalNotes', arr.indexOf('CLINICAL_NOTESUS') !== -1);      
                                   this.$store.commit('setUseVitalSign', arr.indexOf('VITAlSIGNS') !== -1); 
                                   this.$store.commit('setUsePatientAllergies', arr.indexOf('PATIENTALLERGIES') !== -1);   
                                   this.$store.commit('setUsePatientSpecialPr', arr.indexOf('PATIENTSPECIALPR') !== -1); 
                                   this.$store.commit('setUsePatientMarsAlert', arr.indexOf('PATIENTMARALERT') !== -1); 
                                   this.$store.commit('setUseChartReview', arr.indexOf('CHART') !== -1);
                                   this.$store.commit('setUsePatientDocument', arr.indexOf('PATIENTDOCUMENTS') !== -1);
                                   this.$store.commit('setUseEPharmacyNewCrop', arr.indexOf('NEWCROP') !== -1);
                                   this.$store.commit('setCompleteDraft', arr.indexOf('COMPLETEDRAFT') !== -1);
                                   this.$store.commit('setSchedulerClinical', arr.indexOf('SCHED_CLINICAL') !== -1);
                                   this.$store.commit('setAppointments', arr.indexOf('APPOINTMENTS') !== -1);
                                   this.$store.commit('setTreatmentPlanClinical', arr.indexOf('TREATMENTPLAN') !== -1);
                                   this.$store.commit('setUsePatientAlerts', arr.indexOf('ALERTS') !== -1);
                                   this.$store.commit('setUsePatientActivities', arr.indexOf('NOTES') !== -1);
                                   this.$store.commit('setUsePatientClaims', arr.indexOf('PATIENTCLAIMS') !== -1);
                                   this.$store.commit('SetPhysiciansOrder', arr.indexOf('ORDERS') !== -1);
                                   this.$store.commit('setUseTestResult', arr.indexOf('TESTRESULTS') !== -1);
                              } else {
                                   this.setAllPermissions(true)
                              }
                         }
                         })
                         .catch((error) => {
                              if(error.response) {
                                   this.showMessage(this.$tc('Msg.Error'),error,"error");
                              }
                         });
          },

          setAllPermissions(value){
               this.$store.commit('setUseLetters',value);
               this.$store.commit('setUseMars',value);
               this.$store.commit('setUsePatientInfo',value);
               this.$store.commit('setUsePatientInsurance',value);
               this.$store.commit('setUsePatientContact',value);
               this.$store.commit('setUseASAM',value);                                         
               this.$store.commit('setUseClinicalNotes',value);
               this.$store.commit('setUseVitalSign',value);
               this.$store.commit('setUsePatientAllergies',value);
               this.$store.commit('setUsePatientSpecialPr',value);
               this.$store.commit('setUsePatientMarsAlert',value);
               this.$store.commit('setUsePatientAdmission',value);
               this.$store.commit('setUseChartReview',value);
               this.$store.commit('setUseTransfer',value);
               this.$store.commit('setUseDischarge',value);
               this.$store.commit('setUsePatientDiagnosis',value);
               this.$store.commit('setUsePatientDocument',value);      
               this.$store.commit('setDailyNotes',value); 
               this.$store.commit('setLogNotes',value); 
               this.$store.commit('setUseEPharmacyNewCrop',value); 
               this.$store.commit('setUseMedications',value);
               this.$store.commit('setCompleteDraft',value);
               this.$store.commit('setAppointments',value); 
               this.$store.commit('setSchedulerClinical',value); 
               this.$store.commit('setTreatmentPlanClinical',value);
               this.$store.commit('setUsePatientAlerts',value);   
               this.$store.commit('setUsePatientActivities',value);  
               this.$store.commit('setUsePatientClaims',value);   
               this.$store.commit('SetPhysiciansOrder',value);  
               this.$store.commit('setUseDrugInboxFill',value);
               this.$store.commit('setUseDrugInboxAllergies',value);
               this.$store.commit('setUseDrugInboxFormularyStatus',value);
               this.$store.commit('setUseDrugInboxDrugInfo',value);
               this.$store.commit('setUseDrugInboxPatientInfo',value);
               this.$store.commit('setUseDrugInboxPharmacyNotes',value);
               this.$store.commit('setUseDrugInboxPrescription',value);
               this.$store.commit('setUseDrugInboxPrintMedLabel',value);
               this.$store.commit('setUseDrugInboxPrintMedicationHistory',value);
               this.$store.commit('setUseDrugInboxReturnedItems',value);
               this.$store.commit('setUseDrugInboxSetToChargeable',value);
               this.$store.commit('setUseDrugInboxSetToPending',value);
               this.$store.commit('setUseDrugInboxSetToUnableToFill',value);
               this.$store.commit('setUseDrugInboxSetToValid',value);
               this.$store.commit('setUseDrugInboxUndoFillOrder',value);
               this.$store.commit('setUseDrugInboxUndoSetToChargeable',value);
               this.$store.commit('setUseDrugInboxUndoSetToPending',value);
               this.$store.commit('setUseDrugInboxUndoValidated',value);
               this.$store.commit('setUseTestResult',value);
          },

          setAllReadOnly(value){
               this.$store.commit('setLettersEHRReadOnly',value);
               this.$store.commit('setASAMEHRReadOnly',value);
               this.$store.commit('setPatientInfoEHRReadOnly',value);
               this.$store.commit('setPatientInsuranceEHRReadOnly',value);
               this.$store.commit('setPatientContactsEHRReadOnly',value);
               this.$store.commit('setClinicalNotesEHRReadOnly',value);
               this.$store.commit('setVitalSignEHRReadOnly',value);
               this.$store.commit('setPatientAllergiesEHRReadOnly',value);
               this.$store.commit('setPatientSpecialPrEHRReadOnly',value);
               this.$store.commit('setPatientMarsAlertEHRReadOnly',value);
               this.$store.commit('setPatientAdmissionEHRReadOnly',value);
               this.$store.commit('setClinicalTransferEHRReadOnly',value);
               this.$store.commit('setClinicalMedicationsEHRReadOnly',value);
               this.$store.commit('setClinicalDischargeEHRReadOnly',value);
               this.$store.commit('setPatientDiagnosisEHRReadOnly',value);
               this.$store.commit('setPatientDocumentEHRReadOnly',value);
               this.$store.commit('setSchedulerClinicalEHRReadOnly',value);
               this.$store.commit('setAppointmentsEHRReadOnly',value);
               this.$store.commit('setTreatmentPlanEHRReadOnly',value);
               this.$store.commit('setEPrescribingEHRReadOnly',value); 
               this.$store.commit('setMarsEHRReadOnly',value);
               this.$store.commit('setTarsEHRReadOnly',value);    
               this.$store.commit('setPatientAlertsEHRReadOnly',value); 
               this.$store.commit('setPatientActivitiesEHRReadOnly',value);  
               this.$store.commit('setPatientClaimsEHRReadOnly',value);
               this.$store.commit('setPhysiciansOrderEHRReadOnly',value);  
               this.$store.commit('setDrugInboxFillEHRReadOnly',value);
               this.$store.commit('setDrugInboxAllergiesEHRReadOnly',value);
               this.$store.commit('setDrugInboxFormularyStatusEHRReadOnly',value);              
               this.$store.commit('setDrugInboxDrugInfoEHRReadOnly',value);
               this.$store.commit('setDrugInboxPatientInfoEHRReadOnly',value);
               this.$store.commit('setDrugInboxPharmacyNotesEHRReadOnly',value);
               this.$store.commit('setDrugInboxPrescriptionEHRReadOnly',value);
               this.$store.commit('setDrugInboxPrintMedLabelEHRReadOnly',value);
               this.$store.commit('setDrugInboxPrintMedicationHistoryEHRReadOnly',value);
               this.$store.commit('setDrugInboxReturnedItemsEHRReadOnly',value);
               this.$store.commit('setDrugInboxSetToChargeableEHRReadOnly',value);
               this.$store.commit('setDrugInboxSetToPendingEHRReadOnly',value);
               this.$store.commit('setDrugInboxSetToUnableToFillEHRReadOnly',value);
               this.$store.commit('setDrugInboxSetToValidEHRReadOnly',value);
               this.$store.commit('setDrugInboxUndoFillOrderEHRReadOnly',value);
               this.$store.commit('setDrugInboxUndoSetToChargeableEHRReadOnly',value);
               this.$store.commit('setDrugInboxUndoSetToPendingEHRReadOnly',value);
               this.$store.commit('setDrugInboxUndoValidatedEHRReadOnly',value);
          },

          isNoteReadOnly(NotesId){
               let isReadOnly = false;
               this.EHRReadOnlyList.forEach(element => {
                    if(element.notesid === NotesId){
                         isReadOnly = element.isReadOnly
                    }
               });
               return isReadOnly
          }
     }
}